<script setup>
import RiverWaterLevelTab from '@/components/boundary-condition/RiverWaterLevelTab.vue'
import SettlementTab from '@/components/boundary-condition/SettlementTab.vue'
import CrestLevelBoundaryConditionsTab from '@/components/boundary-condition/CrestLevelBoundaryConditionsTab.vue'
import HydraulicHeadBoundaryConditionsTab from '@/components/boundary-condition/HydraulicHeadBoundaryConditionsTab.vue'
import { useStore } from 'vuex'
import { computed, markRaw } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const store = useStore()
const route = useRoute()
const router = useRouter()
const currentProject = computed(() => store.state.project.currentProject)
const tab = computed({
  get() {
    return route.query.tab
  },
  set(value) {
    router.replace({ query: { tab: value } })
  }
})

const tabs = computed(() => {
  return [
    {
      value: 'river-water-level',
      label: 'River Water Level',
      component: markRaw(RiverWaterLevelTab)
    },
    {
      value: 'settlement',
      label: 'Settlement',
      component: markRaw(SettlementTab)
    },
    {
      value: 'crest-level',
      label: 'Crest Level',
      component: markRaw(CrestLevelBoundaryConditionsTab)
    },
    {
      value: 'hydraulic-head',
      label: 'Hydraulic Head',
      component: markRaw(HydraulicHeadBoundaryConditionsTab)
    }
  ]
})
</script>

<template>
  <v-row no-gutters>
    <v-col class="hidden-sm-and-down" cols="1"></v-col>
    <v-col cols="12">
      <v-card-title>Boundary conditions</v-card-title>
      <v-card-subtitle> Please import and define the boundary conditions </v-card-subtitle>
      <div class="ma-3">
        <v-tabs v-model="tab" center-active grow>
          <template v-for="item in tabs" :key="item.value">
            <v-tab :value="item.value" rounded="0">
              {{ item.label }}
            </v-tab>
          </template>
        </v-tabs>
        <v-window v-model="tab" v-if="currentProject.id">
          <v-window-item
            v-for="item in tabs"
            class="fill-height"
            :value="item.value"
            :key="item.value"
          >
            <component :is="item.component" />
          </v-window-item>
        </v-window>
      </div>
    </v-col>
    <v-col class="hidden-sm-and-down" cols="1"></v-col>
  </v-row>
</template>
